export const apiURl = (window.location.hostname === "localhost"
    ? window.env.REACT_APP_API_URL
    : window.location.hostname.startsWith("aifr.lakonnect.com.pk")
    ? "https://aifr.lakonnect.com.pk/api"
    : `${window.location.protocol}//${window.location.hostname}:8000/api`);

export const assetUrl = (window.location.hostname === "localhost"
    ? window.env.REACT_APP_SERVER_ASSET_URL
    : window.location.hostname.startsWith("aifr.lakonnect.com.pk")
    ? "https://aifr.lakonnect.com.pk/"
    : `${window.location.protocol}//${window.location.hostname}:8000/`);
    export const socketUrl=(window.location.hostname==="localhost"?
    window.env.REACT_APP_SOCKET_URL
    :window.location.hostname.startsWith("aifr.lakonnect.com.pk")
    ? "https://aifr.lakonnect.com.pk"
    : `${window.location.protocol}//${window.location.hostname}:8000`)
